import React, { useEffect, useState } from "react";
import moment from "moment-jalaali";
import { Button, Col, message, Row, Slider, Space } from "antd";
import PageContainer from "../../../components/PageContainer";
import { calculateInflationRateService } from "../wiki.api";
import Banner from "../../../images/wiki/Mask Group 206.png";
import {
  checkValue,
  convertNumToEn,
  convertNumToFa,
} from "../../../constant/helper";
import CustomJustDigits from "../../profile/components/CustomInputJustDigit";
import { Messages } from "../../../components/Messages";

const size = 24;

function WikiCalculator() {
  // const { pathname, search } = useLocation();

  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(0);

  const [years, setYears] = useState({
    previousYear: 1394,
    currentYear: 1399,
    amount: "",
  });

  const [TimeSpan, setTimeSpan] = useState({ start: 1348, end: 1400 });

  const handleCredential = (event) => {
    let value = event.target.value;
    const name = event.target.name;

    // if (name === "previousYear" && name < years.currentYear) {
    // }

    if (name === "amount") {
      if (value.length > 0) {
        value = Number(convertNumToEn(value.replace(/(,*)/g, "")));
      } else {
        value = "";
      }
    }

    setYears((previos) => ({ ...previos, [name]: value }));
  };

  const handleCalculate = () => {
    if (years.amount < 1) {
      message.error("مبلغ وارد شده نامعتبر میباشد");
      return true;
    }
    setLoading(true);
    calculateInflationRateService(years)
      .then((res) => {
        let num = res.data.toFixed(2);
        num = parseFloat(num);
        num = num.toLocaleString("fa");
        num = convertNumToFa(num);
        setValue(num);
      })
      .catch((error) => {
        // errorMessageHandler(error);
        message.error(
          `اطلاعات تورم در سال های ${years.previousYear} الی ${years.currentYear} در سیستم موجود نیست.`
        );
        setValue(convertNumToFa(0));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    const momentJalali = moment();
    momentJalali.locale("fa");
    momentJalali.format("YYYY");
    const currentJalaliYear = momentJalali.jYears();

    setTimeSpan((preivios) => ({
      ...preivios,
      end: currentJalaliYear,
    }));
  }, []);

  return (
    <PageContainer
      classNames="calculator"
      loading={loading}
      headerProps={{
        right: (
          <Messages />
          // <Link
          //   className="messages-link"
          //   to={{
          //     pathname: "/messages",
          //     state: { prevPath: pathname + search },
          //   }}
          // >
          //   <Badge>
          //     <MailOutlined />
          //   </Badge>
          // </Link>
        ),
        content: "محاسبه گر حقوقی",
        // className: "pos-absolute",
        link: "/wiki",
      }}
      direction={"ltr"}
    >
      <div className="banner-wrapper">
        <img src={Banner} alt="banner" className="banner" />
      </div>

      <div className="rows mt-4">
        <div className="title">محاسبه ی نرخ تورم از سال:</div>
        <CustomJustDigits
          name="previousYear"
          className="year-input"
          value={convertNumToFa(years.previousYear)}
          onInput={handleCredential}
          disabled
        />
      </div>
      <Row>
        <Col span={24}>
          <Slider
            className="year-slider"
            value={years.previousYear}
            min={TimeSpan.start}
            max={TimeSpan.end}
            onChange={(value) =>
              setYears((previos) => ({ ...previos, previousYear: value }))
            }
            tooltipVisible={false}
          />
          <div className="slider-tracker" />
        </Col>
      </Row>
      <div className="rows mt-5">
        <div className="title">محاسبه ی نرخ تورم تا سال:</div>
        <CustomJustDigits
          name="previousYear"
          className="year-input"
          disabled
          value={convertNumToFa(years.currentYear)}
          onInput={handleCredential}
        />
      </div>
      <Row>
        <Col span={24}>
          <Slider
            className="year-slider"
            value={years.currentYear}
            min={TimeSpan.start}
            max={TimeSpan.end}
            onChange={(value) =>
              setYears((previos) => ({ ...previos, currentYear: value }))
            }
            tooltipVisible={false}
          />
        </Col>
      </Row>
      <Space size={size} direction="vertical">
        <div className="rows mt-5">
          <div className="title">مبلغ را به ریال وارد کنید:</div>
          <CustomJustDigits
            name="amount"
            className="value-input"
            placeholder="ریال"
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => value.replace(/(,*)/g, "")}
            value={convertNumToFa(years.amount)}
            onInput={handleCredential}
          />
          {/* <InputNumber
            name="amount"
            className="value-input"
            placeholder="ریال"
            formatter={(value) =>
              `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }
            parser={(value) => value.replace(/(,*)/g, "")}
            value={`${years.amount}`}
            onInput={handleCredential}
          />*/}
        </div>

        <Row>
          <Col span={24}>
            <Button
              className={"calculator-btn"}
              loading={loading}
              onClick={(e) => {
                if (checkValue(years.amount) && !isNaN(years.amount)) {
                  return handleCalculate(e);
                }
                message.error("مبلغ وارد شده نا معتبر می باشد");
              }}
            >
              محاسبه
            </Button>
          </Col>
        </Row>

        <div className="rows">
          <div className="result-wrapper">
            <div className="amount">
              <div className="title">محاسبه ی نرخ تورم:</div>
              <div className="inflation-amount">
                {value ? value : convertNumToFa("0")}
                {" ریال"}
              </div>
            </div>
          </div>
        </div>
        <div className="rows mt-3">
          <div className="warning">
            <span className="icon icon-wiki-calc-warn" />
            <div className="text">
              نرخ تورم اعلام شده در لاوین برابر با نرخ اعلامی بانک مرکزی جمهوری
              اسلامی ایران است
            </div>
          </div>
        </div>
      </Space>
    </PageContainer>
  );
}

export default WikiCalculator;
